module.exports = __webpack_public_path__ + "nc_static/media/question-mark.46157e18.svg";